import { render, staticRenderFns } from "./MirroredIcon.vue?vue&type=template&id=98d71102&"
import script from "./MirroredIcon.vue?vue&type=script&lang=js&"
export * from "./MirroredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports